import React, { useRef, useState } from "react";
// import './Login.css';
import "./ForgetPassword.css";
import Logo from "../../../assets/images/auth/Logo.svg";
import { AppDispatch } from "../../../redux/store";
import { useDispatch } from "react-redux";
import { forgetPassword } from "../../../redux/counterSlice";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { showError, showSuccess } from "../../../util/ShowStatus";
import { Toast } from "primereact/toast";
import { getErrorMessage } from "../../../helper/getResponseMessage";
const ForgetPassword: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const toast = useRef<Toast>(null);

  const navigate = useNavigate();

  const [userEmail, setEmail] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await dispatch(forgetPassword({ userEmail })).unwrap();

      // If we reach here, the request was successful
      showSuccess(response.Message, toast);
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="login-container">
        <div className="login-left">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={Logo}
              alt="logo"
              width="450"
              height="450"
              style={{ marginTop: "0%" }}
            />
          </div>
        </div>
        <div className="login-right">
          <div className="login-form">
            <h2>Forgot password?</h2>
            <p className="tw-mt-[15px] tw-mb-[25px]">
              No worries,we'll send you reset instructions.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <FloatLabel>
                  <InputText
                    id="username"
                    value={userEmail}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <label htmlFor="username">Email *</label>
                </FloatLabel>
              </div>

              <button type="submit" className="login-button tw-mt-0">
                {loading ? "Loading....." : "Reset password"}
              </button>
            </form>
            <div className="tw-text-center tw-mt-4 tw-font-semibold tw-leading-5 tw-text-[#555555]">
              <Button
                label="Back to Login"
                icon="pi pi-angle-left"
                onClick={() => navigate("/")}
                link
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
